export const AVAILABILITY_REMINDER_DAYS_TO_CHECK = 5;
export const AVAILABILITY_REMINDER_MESSAGE =
  `Your availability is incomplete. Please enter your availability for each of the next ${AVAILABILITY_REMINDER_DAYS_TO_CHECK} days.`;
export const AVAILABILITY_TAB_QUERY_PARAM = 'tab';
export const AVAILABILITY_TAB_QUERY_VALUE = 'availability';
